export default "__VITE_ASSET__42d489d0__"